import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredType?: 'athlete' | 'company';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredType }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    const loginPath = requiredType === 'company' ? '/auth/company-login' : '/auth/athlete-login';
    localStorage.setItem('redirect_after_login', location.pathname);
    return <Navigate to={loginPath} state={{ from: location.pathname }} replace />;
  }

  if (requiredType && user.userType !== requiredType) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
